import React from "react";

import ErrorMessage from "@toolbox/design/ErrorMessage";
import T from "@translate/T";

class DocumentPairError extends React.PureComponent {
    public render() {
        return (
            <ErrorMessage header={<T>Document finding error</T>}>
                <T>
                    Error communicating with server to find document. Your
                    document might be in another project.
                </T>
            </ErrorMessage>
        );
    }
}

export default DocumentPairError;
